import React from "react";

interface CommentHeaderProps {
  pageType: "article" | "shorts" | "movie";
  totalCommentCount: number; // 所有评论条数（后端+本地）
  showCommentLink?: boolean; // 是否展示“当前多少条评论”跳转链接（仅 article）
  commentLink?: string;      // 跳转链接（仅 article）
  articleCommentTotal?: number; // article 类型下展示的评论总数（后端返回）
}

const CommentHeader: React.FC<CommentHeaderProps> = ({
  pageType,
  totalCommentCount,
  showCommentLink = false,
  commentLink = "#",
  articleCommentTotal = 0,
}) => {
  if (pageType === "shorts" || pageType === "movie") {
    return (
      <div className="mb-20 flex justify-start items-center">
        <h2 className="text-24 text-[600] text-[#333333] leading-30 mr-8">留言</h2>
        <span className="font-14 text-[#999999] leading-20">
          {totalCommentCount}條
        </span>
      </div>
    );
  }

  if (pageType === "article") {
    return (
      <div className="mb-20 flex justify-between items-center">
        <h2 className="text-24 text-[600] text-[#333333] leading-30 mr-8">發佈我的評論</h2>
        {showCommentLink && (
          <a
            className="flex text-16 text-[#333333]"
            href={commentLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            當前<b className="text-[#0a88ec]">{articleCommentTotal}</b>條評論{`>>`}
          </a>
        )}
      </div>
    );
  }

  return null;
};

export default CommentHeader;
